<template>
  <div
    class="artLibraryDialog"
    @pointerdown="onMaskPointerDown"
    @pointerup="onMaskPointerUp"
    @pointercancel="resetMaskPointer"
  >
    <div class="artLibraryMain" v-if="dialogType == 0 || dialogType == 1" @click="((event)=>onItemClick(event))">
      <div class="back">
        <PDFStatsButton :iconFont="`icon-icon_close`" customFontSize="14px" paddingTop="0 0" paddingH="0 0" @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="dialogTitle">{{ dialogType == 0 ? $t("art_add_title") : $t("art_file_reset_name")}}</div>
      <div class="changeName">
        <div class="left">
          <div class="art-import">*</div>
          <div class="art-name-title">{{$t("art_name")}}</div>
        </div>
        <div class="art-input-div">
          <input
              type="text"
              class="chooseSelectInput"
              :placeholder="`${$t('art_create_placeholder')}`"
              v-model="artParams.artName"
              @input="handleInput"
              @blur="()=>{error = false}"
          />
          <div style="display: flex; flex-direction: row; align-items: center; margin-top: 10px;" v-if="error">
            <i class="iconfont icon-icon_question" style="font-size: 16px; color: #E14C25;" />
            <div class="redTips">{{ errorType == 1 ? $t('art_name_equal') : $t('art_dialog_tips') }}</div>
          </div>
          <p class="input-position">{{ artParams && artParams.artName ? artParams.artName.length : 0 }}/50</p>
        </div>
        
      </div>

      <div class="bottom">
        <PDFStatsButton :title="$t(`cancel`)" :color="`#ffffff`" :textColor="'#2690E1'" customFontSize="14px" paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
        <div style="width: 20px" />
        <PDFStatsButton :title="$t(`confirm`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onCreateArt())"/>
      </div>
    </div>
    <div class="artLibraryMain" v-if="dialogType == 2 || dialogType == 3" @click="((event)=>onItemClick(event))">
      <div class="back">
        <PDFStatsButton :iconFont="`icon-icon_close`" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="dialogTitle">{{ $t("art_delete_title")}}</div>
      <div class="changeName">
        <div class="art-name-title" style="text-align: center;">{{$t("art_delete_tip")}}</div>
      </div>
      <div class="bottom">
        <PDFStatsButton :title="$t(`cancel`)" :color="`#ffffff`" :textColor="'#2690E1'" customFontSize="14px" paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
        <div style="width: 20px" />
        <PDFStatsButton :title="$t(`art_delete`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onCreateArt())"/>
      </div>
    </div>
    <div class="artLibraryMain" v-if="dialogType == 4" @click="((event)=>onItemClick(event))">
      <div class="back">
        <PDFStatsButton :iconFont="`icon-icon_close`" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="dialogTitle">{{ $t("warmReminder")}}</div>
      <div class="changeName">
        <div class="art-name-title" style="text-align: center;" v-if="userInfo.vipLevel > 0">{{ userInfo.vipLevel != 2 ? $t("art_dialog_row_vip_tip").replace("*",userRights.value.termSingleTbSize).replace("*",userRights.value.svip.termSingleTbSize)
         : $t("art_dialog_row_svip_tip").replace("*",userRights.termSingleTbSize)}}</div>
        <div class="art-name-title" style="text-align: center;" v-else>{{ $t("art_dialog_row_user_tip").replace("*",userRights.termSingleTbSize).replace("*",userRights.value.vip.termSingleTbSize)}}</div>
      </div>
      <div class="bottom" v-if="userInfo.vipLevel == 2">
        <PDFStatsButton :title="$t(`confirm`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="bottom" v-else>
        <PDFStatsButton :title="$t(`cancel`)" :color="`#ffffff`" :textColor="'#2690E1'" customFontSize="14px" paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
        <div style="width: 20px" />
        <PDFStatsButton :title="userInfo.vipLevel > 0 ? $t(`art_dialog_bottom_btn_svip`) : $t(`art_dialog_bottom_btn_vip`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onCreateArt())"/>
      </div>
    </div>
    <div class="artLibraryMain" v-if="dialogType == 5" @click="((event)=>onItemClick(event))">
      <div class="back">
        <PDFStatsButton :iconFont="`icon-icon_close`" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="dialogTitle">{{ $t("warmReminder")}}</div>
      <div class="changeName">
        <div class="art-name-title" style="text-align: center;">{{ userInfo.vipLevel != 2 ? $t("art_dialog_max_vip_tip").replace("*",userRights.termMultiTbSize).replace("*",userRights.value.svip.termMultiTbSize)
         : $t("art-dialog-max-svip-tip").replace("*",userRights.termMultiTbSize)}}</div>
      </div>
      <div class="bottom" v-if="userInfo.vipLevel != 2">
        <PDFStatsButton :title="$t(`cancel`)" :color="`#ffffff`" :textColor="'#2690E1'" customFontSize="14px" paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
        <div style="width: 20px" />
        <PDFStatsButton :title="$t(`art_dialog_bottom_btn_svip`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onCreateArt())"/>
      </div>
      <div class="bottom" v-else>
        <PDFStatsButton :title="$t(`confirm`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
    </div>
    <div class="artLibraryMain" v-if="dialogType == 6" @click="((event)=>onItemClick(event))">
      <div class="back">
        <PDFStatsButton :iconFont="`icon-icon_close`" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="dialogTitle">{{ $t("art_delete_entry")}}</div>
      <div class="changeName">
        <div class="art-name-title" style="text-align: center;">{{$t("art_dialog_delete_tips")}}</div>
      </div>
      <div class="bottom">
        <PDFStatsButton :title="$t(`cancel`)" :color="`#ffffff`" :textColor="'#2690E1'" customFontSize="14px" paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
        <div style="width: 20px" />
        <PDFStatsButton :title="$t(`art_delete`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onCreateArt())"/>
      </div>
    </div>
    <div class="artLibraryMain" v-if="dialogType == 7" @click="((event)=>onItemClick(event))">
      <div class="back">
        <PDFStatsButton :iconFont="`icon-icon_close`" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="dialogTitle">{{ $t("warmReminder")}}</div>
      <div class="changeName">
        <div class="art-name-title" style="text-align: center;">{{ $t("art_dialog_equal") }}</div>
      </div>
      <div class="bottom">
        <PDFStatsButton :title="$t(`confirm`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
    </div>
    <div class="artLibraryMain" v-if="dialogType == 8" @click="((event)=>onItemClick(event))">
      <div class="back">
        <PDFStatsButton :iconFont="`icon-icon_close`" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="dialogTitle">{{ $t("art_use_table")}}</div>
      <div class="art-info-show">
        <div v-if="(!parmas || !parmas.list || parmas.list.length == 0)" class="art-name-title">{{ $t('art_dialog_delete_tip') }}</div>
        <div class="info-item" v-for="(item, index) in (parmas && parmas.list)">
          {{ item.termName || item.useTermName }}
        </div>
      </div>
      <div class="bottom">
        <PDFStatsButton :title="$t(`confirm`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
    </div>
    <div class="artLibraryMain" v-if="dialogType == 9" @click="((event)=>onItemClick(event))">
      <div class="back">
        <PDFStatsButton :iconFont="`icon-icon_close`" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="dialogTitle">{{ $t("warmReminder")}}</div>
      <div class="changeName">
        <div class="art-name-title" style="text-align: center;">{{ $t("art_dialog_error_tip") }}</div>
      </div>
      <div class="bottom">
        <PDFStatsButton :title="$t(`confirm`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
    </div>
    <div class="artLibraryMain" v-if="dialogType == 10" @click="((event)=>onItemClick(event))">
      <div class="back">
        <PDFStatsButton :iconFont="`icon-icon_close`" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="dialogTitle">{{ $t("warmReminder")}}</div>
      <div class="changeName">
        <div class="art-name-title" style="text-align: center;" v-if="userInfo.vipLevel > 0">{{ userInfo.vipLevel != 2 ? $t("art_dialog_create_max_vip_tip").replace("*",userRights.termMaxSize).replace("*",userRights.svip.termMaxSize)
         : $t("art_dialog_create_max_svip_tip").replace("*",userRights.termMaxSize).replace("*",userRights.svip.termMaxSize)}}</div>
        <div class="art-name-title" style="text-align: center;" v-else>{{ $t("art_dialog_create_max_user_tip").replace("*",userRights.termMaxSize).replace("*",userRights.vip.termMaxSize)}}</div>
      </div>
      <div class="bottom" v-if="userInfo.vipLevel == 2">
        <PDFStatsButton :title="$t(`confirm`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="bottom" v-else>
        <PDFStatsButton :title="$t(`cancel`)" :color="`#ffffff`" :textColor="'#2690E1'" customFontSize="14px" paddingTop="0 0" :borderStyle="'#2690E1 solid 1px'" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
        <div style="width: 20px" />
        <PDFStatsButton :title="userInfo.vipLevel == 1 ? $t(`art_dialog_bottom_btn_svip`) : $t(`art_dialog_bottom_btn_vip`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onCreateArt())"/>
      </div>
    </div>
    <div class="artLibraryMain" v-if="dialogType == 11" @click="((event)=>onItemClick(event))">
      <div class="back">
        <PDFStatsButton :iconFont="`icon-icon_close`" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
      <div class="dialogTitle">{{ $t("warmReminder")}}</div>
      <div class="changeName">
        <div class="art-name-title" style="text-align: center;">{{ $t("account_art_dialog_permission_tips") }}</div>
      </div>
      <div class="bottom">
        <PDFStatsButton :title="$t(`account_art_dialog_iKonw_btn`)" :color="`#2590E1`" textColor="white" :borderStyle="'#2690E1 solid 1px'" customFontSize="14px" paddingTop="0 0" paddingH="0 0"  @ButtonClick="(()=> onClose())"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import eventBus from 'vue3-eventbus'
import PDFStatsButton from "@/components/Button/PDFStatsButton.vue";
import useUserStore from "@/store/modules/user";
import {storeToRefs} from "pinia";
import {defineEmits, ref, inject} from "vue";
import Toast from "~/utils/toast";
import {useI18n} from "vue-i18n";
import {useRouter} from "vue-router";

const { t } = useI18n()
const userStore = useUserStore();
const { userInfo, userRights} = storeToRefs(userStore);
const router = useRouter()
const route = useRoute()
const artParams = ref({artName: ''})
const error = ref(false)
const errorType = ref(0)
let maskPointerStartedOnOverlay = false

const props = defineProps({
  dialogType: {
    type: Number, // 0 添加术语库 1 术语库重命名 2 术语库删除 4 单文件词条超过 5 总词条超过 6 删除词条 7 存在相同名字 8 术语库提示 9 文件错误 10 术语表创建超出上限 11 无权限编辑
  },
  file: {
    type: Object,
    default: null
  },
  parmas: {
    type: Object,
    default: {}
  }
})

let call = defineEmits(["onClose", "onConfirm"])
defineExpose({ showErrorText })

const handleInput = (event) => {
  let value = event.target.value
  //输入位数限制
  if (value.length > 50) {
    value = value.slice(0, 50)
  }
  if (value.startsWith(' ')) {
    value = value.trimStart(); // 去掉开头的空格
    event.target.value = value; // 更新输入框的值
  }
  artParams.value.artName = value
}

function onItemClick(e :Event) {
  e.stopPropagation()
}

function onMaskPointerDown(event: PointerEvent) {
  maskPointerStartedOnOverlay = event.target === event.currentTarget
}

function onMaskPointerUp(event: PointerEvent) {
  const shouldClose = maskPointerStartedOnOverlay && event.target === event.currentTarget
  resetMaskPointer()
  if (shouldClose) onClose()
}

function resetMaskPointer() {
  maskPointerStartedOnOverlay = false
}

function onClose() {
  call("onClose")
}

function onCreateArt() {
  if ((props.dialogType == 0 || props.dialogType == 1) && (!artParams.value.artName || artParams.value.artName.length == 0)) {
    errorType.value = 2
    error.value = true
    return
  }
  call("onConfirm", props.dialogType, {termName: artParams.value.artName})
}

function showErrorText() {
  console.log("showErrorText")
  error.value = true
  errorType.value = 1
}

onMounted(()=>{
  console.log("asdadad===", props.parmas)
  if (props.parmas && props.dialogType == 1) {
    artParams.value.artName = props.parmas.termName
  }
})

</script>

<style scoped lang="scss">
.artLibraryDialog {
  flex-direction: column;
  width: 100%;
  height: 100vh;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  .artLibraryMain {
    display: flex;
    width: 400px;
    background-color: white;
    border-radius: 8px;
    flex-direction: column;
    position: relative;
    align-items: center;
    padding: 0 20px;
    .dialogTitle{
      margin-top: 40px;
      font-size: 16px;
      font-weight: bold;
      color: var(--text-color);
    }
    .back {
      align-self: flex-end;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 20px;
    }
    .changeName {
      display: flex;
      flex-direction: row;
      margin-top: 20px;
      width: 96%;
      // align-items: center;
      position: relative;
      .input-position {
        position: absolute;
        right: 10px;
        top: 12px;
        color: #BFBFBF;
        font-size: 14px;
      }
      .left {
        display: flex;
        flex-direction: row;
        height: 40px;
        align-items: center;
        min-width: 100px;
        .art-import {
          color: #E14C25;
          font-size: 14px;
        }
      }
      .art-name-title {
        color: var(--text-color);
        font-size: 14px;
        text-align: center;
        width: 100%;
      }
      .art-input-div {
        display: flex;
        flex-direction: column;
        // flex: 1;
        max-height: 70px;
        justify-content:center;
        position: relative;
        width: 72%;
        .chooseSelectInput {
          font-size: 14px;
          height: 40px;
          border: 1px solid #BFBFBF;
          padding: 0 60px 0 10px;/*清除自带的padding间距*/
          outline: none;/*清除input点击之后的黑色边框*/
          background-color: transparent;
          text-align: start;
          border-radius: 4px;
        }
        input::-webkit-input-placeholder {
          /* placeholder颜色 */
          color: #BFBFBF;
          /* placeholder字体大小 */
          font-size: 14px;
          position: relative;
        }
        .redTips {
          color: #E14C25;
          font-size: 14px;
        }
      }
    }
    .art-info-show {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      width: 100%;
      // align-items: center;
      position: relative;
      flex-wrap: wrap;
      .info-item {
        padding: 5px 10px;
        background-color: #F5F5F5;
        margin: 5px;
        border-radius: 4px 4px 4px 4px;
      }
      .art-name-title {
        color: var(--text-color);
        font-size: 14px;
        text-align: center;
        width: 100%;
      }
    }
    .bottom {
      display: flex;
      margin-top: 30px;
      margin-bottom: 30px;
      flex-direction: row;
      align-items: center;
      height: 40px;
      width: 100%;
    }
  }
}

</style>
<style lang="scss">
.artLibraryDialog input {
    font-size: 12px !important; /* 设置字体大小 */
}
.artLibraryDialog textarea {
  font-size: 12px !important; /* 设置字体大小 */
}
</style>
